'use client'

import * as React from 'react'
import ReactDOM from 'react-dom'
import { ChevronRightIcon } from 'primitives/icons'
import { useTranslations } from 'next-intl'

import { LFS_URL } from '@web/utils/env'

interface HeroBannerProps {
  title?: string
  description?: string
  breadCrumbs?: string[]
}

export function HeroBanner({ title, description, breadCrumbs }: HeroBannerProps) {
  const t = useTranslations('pages.studio_templates')

  ReactDOM.preload(`${LFS_URL}/web/pages/studio/templates/new-hero-banner.png`, {
    // Preload banner image
    // https://nextjs.org/docs/app/api-reference/functions/generate-metadata#link-relpreload
    // @ts-ignore
    as: 'image',
    fetchPriority: 'high',
  })

  return (
    <div
      style={{
        backgroundImage: `url('${LFS_URL}/web/pages/studio/templates/new-hero-banner.png')`,
      }}
      className="rounded-2 flex min-h-[330px] flex-col items-start justify-center bg-[#F1F1F1] bg-[length:auto_180%] bg-[position:calc(100%+100px)] bg-no-repeat max-xl:!bg-none"
    >
      <div className="flex max-w-[600px] flex-col items-start gap-2 px-[29px] lg:gap-4 lg:px-12">
        <div className="flex flex-wrap items-center">
          <span className="text-gray-600">{t('new_hero.fst_breadcrumb')}</span>

          {breadCrumbs?.map((breadcrumb, index) => (
            <React.Fragment key={index}>
              <ChevronRightIcon className="text-gray-400-400 mx-2" />
              <span className="text-nowrap text-gray-600">{breadcrumb}</span>
            </React.Fragment>
          ))}
        </div>

        {title ? (
          <h1 className="text-left text-[24px] font-semibold leading-[36px] text-gray-100 lg:text-[32px] lg:leading-[48px]">
            {title}
          </h1>
        ) : null}

        {description ? <p className="text-13 text-left text-gray-600">{description}</p> : null}
      </div>
    </div>
  )
}
